import DefaultState                 from '../../data/DefaultState';
import { getBomCorrectStatus }      from "../../utils/extracters"

import { IMPORTING, QUOTED, QUOTING_BOM_PARTS }                from '../../data/BomStatus';

export const clearBom = (state, remove_item) => {
  const bom_id = state.id
  const line_item_id = state.line_item_id
  const new_bom_status = getBomCorrectStatus(state.bom_status, remove_item, state.saved)
  if(remove_item || (state.bom_status == IMPORTING && !bom_id)){
    const new_state = _.cloneDeep(DefaultState)
    new_state.id = bom_id
    new_state.name = state.name
    new_state.revision = state.revision
    new_state.board_qtys = state.board_qtys
    new_state.bom_status = new_bom_status
    new_state.view.zip_file_input_id = state.view.zip_file_input_id
    new_state.view.fabrication_slug = state.view.fabrication_slug
    new_state.view.bom_selected = false
    new_state.view.uploaded_zip_file = state.view.uploaded_zip_file
    new_state.view.available_bom_in_zip = state.view.available_bom_in_zip
    if(new_state.view.uploaded_zip_file && new_state.view.available_bom_in_zip) new_state.view.directory = state.view.directory
    if(remove_item && line_item_id){
      new_state.line_item_id = line_item_id
      new_state.view.destroy = true
    }
    
    return {...new_state}
  }
  state.bom_status = new_bom_status
  state.view.bom_selected = [QUOTING_BOM_PARTS, QUOTED].includes(new_bom_status)
  return null
}